import "./Technology.module.css";
import MainHeader from "@/reusable_sections/Header";
import ConversationalCore from "./sections/ConversationalCore";
import CrmIntelligence from "./sections/CrmIntelligence";
import EnterpriseInfrastructure from "./sections/EnterpriseInfrastructure";
import Footer from "@/reusable_sections/Footer";
export default function TechnologyPage() {
  return <div>
      <MainHeader />
      <ConversationalCore />
      <CrmIntelligence />
      <EnterpriseInfrastructure />
      <Footer />
    </div>;
}